<template>
  <div class="container page-content">
    
    <div class="row page-content__heading">
      <div class="col-12">
        <h1>{{ $t('eligible_products.heading') }}</h1>
      </div>
    </div>

    <div class="row">
      
      <div class="col-4 special-box">
        <div class="special-box__inner">
          <img src="@/assets/images/p1.png" alt=""/>
          <div class="inner_name">
            <img src="@/assets/images/ico-washingmachine.png" alt="" />
            {{ $t('common.washingmachines') }}
          </div>
        </div>
      </div>

      <div class="col-4 special-box">
        <div class="special-box__inner">
          <img src="@/assets/images/p2.png" alt=""/>
          <div class="inner_name">
            <img src="@/assets/images/ico-dishwasher.png" alt="" />
            {{ $t('common.dishwashers') }}
          </div>
        </div>
      </div>

      <div class="col-4 special-box">
        <div class="special-box__inner">
          <img src="@/assets/images/p3.png" alt=""/>
          <div class="inner_name">
            <img src="@/assets/images/ico-refrigerator.png" alt="" />
            {{ $t('common.refrigerators') }}
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import { globalStore } from '@/main'
  import scrollToElement from 'scroll-to-element'

  export default {
    name: "eligibleProducts",
    data () {
      return {
        products: [],
        dataIsLoaded: false,
        category: {
          washingmachines: 1,
          dishwashers: 2,
          refrigerators: 3
        }
      }
    },
    mounted () {
      this.fetchProductsData();

      scrollToElement('.page-content', {
        offset: 0,
        ease: 'out-cube',
        duration: 800
      });
    },
    methods: {
      fetchProductsData () {
        let cmp = this
        cmp.axios.get(globalStore.API_BASE_URL + 'products').then((response) => {
          let responseData = response.data
          cmp.products = responseData.data
          cmp.dataIsLoaded = true
        })
      },
      filterProductsByCatId (catId) {
        return this.products.filter(product => product.category_id == catId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    padding-top: 50px;
    padding-bottom: 50px;

    .page-content__heading {
      margin-bottom: 40px;
      
      h1 {
        font-size: 34px;
        font-weight: 300;
      }

      .heading__info {
        font-size: 12px;
        margin-top: 10px;
        font-weight: 400;
      }
    }

    .page-content__products {
      margin-top: 80px;

      .products__heading {
        background: #f0f0f0;
        padding-top: 10px;
        padding-bottom: 10px;
        font-weight: 900;
        font-size: 14px;
        text-transform: uppercase; 
        
        img {
          margin-right: 10px;
        }
      }

      .products__list {
        ul {
          list-style: none;
          padding-left: 20px;
          margin-bottom: 0px;
          margin-top: 20px;
          columns: 3;
          -webkit-columns: 3;
          -moz-columns: 3;

          li {
            margin-bottom: 10px;
          }
        }
      }

    }

    .special-box {

      .special-box__inner {
        padding-top: 40px;
        padding-bottom: 40px;
        text-align: center;
        background: #f0f0f0;
        
        .inner_name {
          margin-top: 40px;
          text-transform: uppercase;
          font-weight: 900;
          vertical-align: middle;

          img {
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>
